import Image from '../classes/utils/media/image'
export default Image
